<div class="layout-footer">{{ 'footer.title' | translate }}</div>